import PropTypes from "prop-types"

// @mui material components
import Card from "@mui/material/Card"
import Divider from "@mui/material/Divider"
import Grid from "@mui/material/Grid"
import Icon from "@mui/material/Icon"

// Material Dashboard 2 React components
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import { Badge, IconButton } from "@mui/material"

function ComplexStatisticsCard({
  color = "info",
  title,
  dataDate,
  count,
  filter,
  percentage,
  icon,
  filterClick,
}) {
  return (
    <Card>
      <MDBox display="flex" justifyContent="space-between" pt={1} px={2}>
        <MDBox
          variant="gradient"
          bgColor={color}
          color={color === "light" ? "dark" : "white"}
          coloredShadow={color}
          borderRadius="xl"
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="4rem"
          height="4rem"
          mt={-3}
        >
          {icon && (
            <Icon fontSize="medium" color="inherit">
              {icon}
            </Icon>
          )}
        </MDBox>
        <MDBox textAlign="right" lineHeight={1} p={1}>
          <Grid container>
            <Grid item xs={12}>
              <MDTypography sx={{ textAlign: "center" }} variant="h6" fontWeight="light">
                {title}
              </MDTypography>
              <MDTypography sx={{ textAlign: "center" }} fontWeight="light" fontSize="12px">
                {dataDate || ""}
              </MDTypography>
            </Grid>
          </Grid>
          <MDTypography variant="h4">{count}</MDTypography>
        </MDBox>
      </MDBox>
      <Divider />
      <MDBox pb={2} px={2}>
        <MDTypography component="p" variant="button" display="flex">
          <MDTypography component="span" variant="button" fontWeight="bold">
            {percentage.amount}
          </MDTypography>
          &nbsp;{percentage.label}
        </MDTypography>
      </MDBox>
    </Card>
  )
}

// Setting default values for the props of ComplexStatisticsCard
ComplexStatisticsCard.defaultProps = {
  color: "info",
  title: "",
  dataDate: "",
  count: 0,
  filter: false,
  percentage: {
    color: "info",
    amount: 0,
    label: "",
  },
  icon: "info",
  filterClick: () => {},
}

// Typechecking props for the ComplexStatisticsCard
ComplexStatisticsCard.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  title: PropTypes.string.isRequired,
  dataDate: PropTypes.string,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  filter: PropTypes.bool,
  percentage: PropTypes.shape({
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "white",
    ]),
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
  }),
  icon: PropTypes.node,
  filterClick: PropTypes.func,
}

export default ComplexStatisticsCard
